import { createFileRoute, redirect } from '@tanstack/react-router'

/** The wizard starts at its cover — `/onboarding` alone is not a screen. */
export const Route = createFileRoute('/onboarding/')({
  beforeLoad: () => {
    throw redirect({ to: '/onboarding/vitejte' })
  },
})
